import { render, staticRenderFns } from "./controlGoodsList.vue?vue&type=template&id=51e4c03e&scoped=true"
import script from "./controlGoodsList.vue?vue&type=script&lang=js"
export * from "./controlGoodsList.vue?vue&type=script&lang=js"
import style0 from "./controlGoodsList.vue?vue&type=style&index=0&id=51e4c03e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e4c03e",
  null
  
)

export default component.exports